export default __webpack_public_path__ + "static/media/01.24c7b1fc.jpg";